import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TextareaBox = styled.div<{ height?: number }>`
  ${({ theme, height }) => css`
    display: block;
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    background: ${theme.backgroundColor.onelevated};

    textarea {
      width: 100%;
      ${height && `height: ${height}px;`}
      padding: 11px 12px;
      ${theme.fontStyle.text.body16_medium}
      color: ${theme.content.content_light_1};
    }
  `}
`;

export const DeleteButton = styled.button`
  display: flex;
  position: absolute;
  top: 50%;
  right: 12px;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
`;

export const TextValueBox = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TextValue = styled.span`
  ${({ theme }) => css`
    display: block;
    ${theme.fontStyle.label.list12_medium}
    color: ${theme.content.caption1};
  `}
`;
